module.exports = __webpack_public_path__ + "img/round-undo-24px.1540d577.svg";